// Marketplace URL-filter helpers — extracted from
// `marketplace/functions/index.js` so canvas's /marketplace deep-link
// surface and the marketplace sub-app pull from one source. Both call
// sites previously cross-imported across packages, which violated the
// Phase 10 no-restricted-imports rule.
//
// `parseFiltersFromSearch(searchString)` returns a partial diff to apply
// to the host root state — only keys that appear in the URL and pass the
// allowed-set guards are present in the output.
//
// FA204 / frank trap — these three tables used to be private module-scope
// consts, re-exported under public names read bare from `parseFiltersFromSearch`'s
// own body: unresolvable once this file's exports are individually
// frank.toJSON'd for platform delivery (project_frank_drops_module_local_helpers).
// The public names stay exported (marketplace/functions/index.js imports
// them cross-file, unaffected by frank); `parseFiltersFromSearch` carries
// its own self-contained local copies instead of reading them bare.
export const URL_ALLOWED_KINDS = [
  'library',
  'template',
  'integration',
  'registrar',
  'plugin',
  'mcp',
  'all'
]
export const URL_ALLOWED_PRICING = ['all', 'free', 'paid', 'installed', 'pinned']
export const URL_ALLOWED_SORTS = ['name', 'priceAsc', 'priceDesc']

// Parse location.search (or any search string) → partial host state diff.
// Returns only keys present + allowed. The synthetic `_itemId` key carries
// the detail-open target for resolution against catalog by the caller.
export const parseFiltersFromSearch = (search) => {
  const allowedKinds = ['library', 'template', 'integration', 'registrar', 'plugin', 'mcp', 'all']
  const allowedPricing = ['all', 'free', 'paid', 'installed', 'pinned']
  const allowedSorts = ['name', 'priceAsc', 'priceDesc']
  const sp = new URLSearchParams(search || '')
  const out = {}
  const kind = sp.get('kind')
  if (kind && allowedKinds.includes(kind)) out.activeKind = kind
  const pricing = sp.get('pricing')
  if (pricing && allowedPricing.includes(pricing)) out.activePricing = pricing
  const sort = sp.get('sort')
  if (sort && allowedSorts.includes(sort)) out.activeSort = sort
  const q = sp.get('q')
  if (typeof q === 'string') out.query = q
  const cats = sp.get('categories')
  if (cats) {
    out.activeCategories = cats
      .split(',')
      .map((c) => c.trim())
      .filter(Boolean)
  }
  const itemId = sp.get('item')
  if (itemId) out._itemId = itemId
  return out
}
